/**
 * Decide which controls fill the composer's right-side action slot.
 *
 * Dictation stays available when files are attached so users can describe a
 * screenshot or image by voice without first typing. Voice mode is a live
 * conversation that does not consume composer attachments, so it only appears
 * on a fully empty composer. Send appears whenever there is something to
 * submit (text, inline params, or files).
 */
export function getComposerActionControls({
  isInferencing = false,
  hideTextInput = false,
  hasAllRequiredFiles = true,
  value = '',
  hasInlineParamValue = false,
  filesLength = 0,
} = {}) {
  if (isInferencing) {
    return { showDictate: false, showVoice: false, showSend: true };
  }

  if (hideTextInput) {
    return {
      showDictate: false,
      showVoice: false,
      showSend: Boolean(hasAllRequiredFiles),
    };
  }

  const hasText = Boolean(value?.trim()) || Boolean(hasInlineParamValue);
  const hasFiles = filesLength > 0;

  return {
    showDictate: !hasText,
    showVoice: !hasText && !hasFiles,
    showSend: hasText || hasFiles,
  };
}
